(function () {
  'use strict';

  /* @ngdoc object
   * @name messages
   * @description
   *
   */
  angular
    .module('messages', [
      'ui.router'
    ]);
}());
